import React from "react";
import { useParams } from "react-router-dom";
import blogData from "./blogData";

const BlogDetail = () => {
  const { id } = useParams();
  const blog = blogData.find((item) => item.id === id);

  if (!blog) {
    return <div className="text-center py-20 text-red-600">Blog not found</div>;
  }

  return (
    <div className="max-w-4xl mx-auto px-4 py-10 sm: mt-10">
      <h1 className="sm:text-4xl font-bold text-center">{blog.title}</h1>
      <div className="flex mt-10 items-center justify-center mb-3"> <p className="text-sm text-center text-[#15b315">
        By: {blog.publishedBy}
      </p>
.
      <p className=" ml-2 text-sm text-center text-[#333] font-semibold ">
        on: {blog.publishedDate}
      </p></div>
     
      <img
        src={blog.image}
        alt={blog.title}
        className="w-full h-[300px] object-cover mb-6 rounded"
      />
      <p className="text-lg text-gray-600 leading-7 whitespace-pre-line">
        {blog.content}
      </p>
      {/* <div className="mt-6">
        <a href="/blogs" className="text-[#15b315] hover:underline">
          ← Back to Blogs
        </a>
      </div> */}
    </div>
  );
};

export default BlogDetail;
